import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

import * as postapi from "../../api/postapi";
import useApi from "../../Hooks/useApi";
import { toast } from "react-toastify";
import { RiSendPlane2Line } from "react-icons/ri";
import styles from "./SendSmsModal.module.css";

function SendSmsModal({ show, data, onHide }) {
  const [text, setText] = useState("");
  const [validated, setValidated] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const sendSMSCall = useApi(postapi.sendSMS, { hasCatchError: true });

  const close = () => {
    setText("");
    setValidated(false);
    setIsClicked(false);
    onHide();
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsClicked(true);
      setValidated(true);
      if (text.length === 0) throw new Error("Enter message to continue this process.");

      const payload = {
        recipientList: [
          {
            cellNumber: data?.customer_phone,
          },
        ],
        message: text,
        channel: "ATM",
      };

      const response = await sendSMSCall.request({ data: payload });

      if (response) {
        toast.success("SMS sent successfully");
        close();
      }
    } catch (error) {
      setIsClicked(false);
      console.error(error.message);
    }
  };

  return (
    <>
      <Modal aria-labelledby="send-sms-modal-title" centered show={show} onHide={close}>
        <Modal.Header className={styles.modalHeader} closeButton>
          <div>
            <h2 className={styles.modalTitle} id="send-sms-modal-title">Send SMS</h2>
            {data?.order_number && data?.customer_name && (
              <p className={styles.modalSubtitle}>Order {data.order_number} · {data.customer_name}</p>
            )}
          </div>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control as={"textarea"} rows={4} value={text} onChange={(e) => setText(e.target.value)} />
            {text.length === 0 && validated ? <span className="text-danger">*Please enter a message</span> : <></>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button className={styles.modalAction} size="sm" variant="outline-secondary" onClick={close}>Cancel</Button>
          <Button className={`${styles.modalAction} ${styles.sendButton}`} size="sm" variant="primary" onClick={handleSubmit} disabled={isClicked}>
            <RiSendPlane2Line aria-hidden="true" /> Send
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SendSmsModal;
